import { devices, medias } from 'assets/styled/tokens';
import styled from 'styled-components';

export const DashBoardContainer = styled.div`
  box-shadow: 0px 1px 8px 0px #0000001a;
  background-color: #ffffff;
  min-width: 515px;
  border-radius: 8px;
  height: 532px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 24px;
  flex: 1;

  hr {
    border: 1px solid #e5e5e5;
    width: 95%;
    margin: 0;
    box-sizing: border-box;
  }

  /* Tablet-specific styles */
  @media (max-width: 1023px) {
    width: 100%;
    min-width: 100%;
    height: auto;
    padding: 20px;
    display: block;

    hr {
      display: none;
    }
  }

  @media screen and (max-width: ${medias.tablet}) {
    width: 100%;
    min-width: 100%;
    height: auto;
    padding: 20px 16px 16px 16px;
    border-radius: 10px;
  }

  @media screen and (max-width: ${medias.desktopMd}) {
    gap: 20px;
    height: auto;
    padding: 20px 16px 16px 16px;
    border-radius: 10px;
  }

  @media ${devices.screen} {
    width: 100%;
  }
  @media (min-width: 1360px) {
    width: 100%;
  }
  @media (min-width: 1440px) {
    width: 100%;
  }
  @media (min-width: 1500px) {
    width: 605px;
  }
  @media (min-width: 1600px) {
    width: 670px;
  }
  @media (min-width: 1700px) {
    width: 755px;
  }
  @media ${devices.screenWide} {
    width: 49%;
  }
`;

export const DashboardInnerContainer = styled.div`
  width: 70%;
  height: 48%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  /* Tablet-specific styles */
  @media (max-width: 1023px) {
    width: 100%;
    height: auto;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;

    &:first-of-type {
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: ${medias.tablet}) {
    flex-direction: column;
    width: 100%;
    margin-top: 12px;
    margin-bottom: 36px;
  }

  :nth-child(3) {
    padding-bottom: 20px;
  }

  h1 {
    font-family: Blinker;
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: 0.5px;
    text-align: left;

    /* Tablet-specific styles */
    @media (max-width: 1023px) {
      font-size: 24px;
      line-height: 28px;
    }
  }

  h2 {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.30000001192092896px;
    text-align: center;
    color: #888888;

    @media screen and (max-width: ${medias.tablet}) {
      text-align: left;
      margin-top: 8px;
    }

    /* Tablet-specific styles */
    @media (max-width: 1023px) {
      text-align: left;
      font-size: 14px;
      line-height: 20px;
    }
  }

  @media ${devices.screen} {
    width: 100%;
  }
`;

export const CirclesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: ${medias.tablet}) {
    gap: 16px;
  }

  /* Tablet-specific styles */
  @media (max-width: 1023px) {
    gap: 20px;
  }

  @media ${devices.screen} {
    width: 70%;
    justify-content: space-evenly;
  }
  @media (min-width: 1380px) {
    width: 60%;
    justify-content: space-evenly;
  }
  @media (min-width: 1500px) {
    width: 55%;
    justify-content: space-evenly;
  }
  @media (min-width: 1600px) {
    width: 50%;
    justify-content: space-evenly;
  }
  @media (min-width: 1700px) {
  }
  @media ${devices.screenWide} {
    width: 272px;
  }
`;

export const TitleContainer = styled.div`
  @media screen and (max-width: ${medias.tablet}) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  /* Tablet-specific styles */
  @media (max-width: 1023px) {
    width: 40%;
  }
`;

export const DashButton = styled.button`
  border: 1px solid #f38a00;
  border-radius: 4px;
  width: 189px;
  height: 40px;
  color: #f38a00;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;
  display: flex;
  background-color: #f5f3f1;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 24px;
  right: 24px;
  :hover {
    color: #fff;
    background-color: #f38a00;
  }

  /* Tablet-specific styles */
  @media (max-width: ${medias.desktopMd}) {
    position: static;
    width: 100%;
    margin: 20px 0;
    position: static;
    right: unset;
    bottom: unset;
  }

  @media screen and (max-width: ${medias.tablet}) {
    position: static;
    margin-left: auto;
  }

  @media screen and (max-width: ${medias.desktopMd}) {
    position: relative !important;
    margin-left: auto;
    bottom: 0;
  }
`;

/* New component for the Novidades section on tablet */
export const CircleBody = styled.div`
  width: 128px;
  height: 128px;
  border-radius: 50%;
  border: 1px solid ${props => props.color};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  /* Tablet-specific styles */
  @media (max-width: 1023px) {
    width: 100px;
    height: 100px;
  }

  > h1 {
    font-family: Blinker;
    font-size: 40px;
    font-weight: 700;
    line-height: 44px;
    letter-spacing: 0.3px;
    text-align: center;
    color: ${props => props.color};

    /* Tablet-specific styles */
    @media (max-width: 1023px) {
      font-size: 32px;
      line-height: 36px;
    }
  }

  > h2 {
    font-family: Blinker;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    color: ${props => props.color} !important;

    /* Tablet-specific styles */
    @media (max-width: 1023px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  svg {
    position: absolute;
    right: 10px;
    top: 10px;

    /* Tablet-specific styles */
    @media (max-width: 1023px) {
      width: 16px;
      height: 16px;
    }
  }
`;
